import { WidgetEvent } from "../enums/widget-event.enum";
import miniWidgetStyles from '../styles/mini-widget.module.scss';
import mainButtonStyles from '../styles/main-button.module.scss';
import { IWidgetNode } from "../interfaces/widget-node.interface";
import { CustomClass } from "../enums/custom-class.enum";
import { EventEmitter } from "../../../components/event-emitter";
import { IFixBlockOptions } from "../../../interfaces/fix-block-options.interface";
import { MiniWidgetPosition } from '../enums/mini-widget-position.enum';

export class MiniWidgetNode implements IWidgetNode {
  
  constructor(
    private readonly options: IFixBlockOptions,
    private readonly eventEmitter: EventEmitter<WidgetEvent>
  ) {}

  private miniWidget: HTMLElement;
  
  public appendToPage() {
    if (this.options.miniWidgetType == "round") {
      this.miniWidget = document.createElement('div');
      this.miniWidget.classList.add(miniWidgetStyles.default);
    } else {
      this.miniWidget = document.createElement('button');
      this.miniWidget.classList.add(mainButtonStyles.miniWidget);
      this.miniWidget.textContent = String(this.options.buttonText);
    }
    
    this.miniWidget.classList.add(miniWidgetStyles.fixed);
    this.miniWidget.dataset.nameSpace = 'dentolo';
    this.miniWidget.id = 'dentolo_mini-widget';
    
    this.miniWidget.classList.add(miniWidgetStyles[this.options?.miniWidgetPosition || ""], miniWidgetStyles.hidden);
    if (window.innerWidth < 780 && this.options.miniWidgetType == "button") {
      this.miniWidget.classList.add(miniWidgetStyles.center);
    }
 
    this.miniWidget.classList.add(CustomClass.MINI_WIDGET);
    this.miniWidget.onclick = event => this.eventEmitter.emit(WidgetEvent.CALL_QUIZ, event);

    for (let width in this.options.appearance) {
      if (window.innerWidth > Number(width)) {
        const style = this.options.appearance[Number(width)].style;
        const hoverStyle = this.options.appearance[Number(width)].hoverStyle;
        
        if (style.miniWidget) {
          for (const property in style.miniWidget) {
            this.miniWidget.style[property] = (style.miniWidget as CSSStyleDeclaration)[property];
          }
        }

        if (hoverStyle?.miniWidget) {
          for (const property in hoverStyle.miniWidget) {
            this.miniWidget.onpointerenter = () => {
              this.miniWidget.style[property] = (hoverStyle.miniWidget as CSSStyleDeclaration)[property];
            }
    
            this.miniWidget.onpointerleave = () => {
              this.miniWidget.style[property] = (style.miniWidget as CSSStyleDeclaration)[property];
            }
          }
        }
      }
    }

    document.body.appendChild(this.miniWidget);
  }

  public show() {
    this.miniWidget.classList.remove(miniWidgetStyles.hidden);
    this.miniWidget.classList.add(miniWidgetStyles.active);
  }

  public hide() {
    this.miniWidget.classList.add(miniWidgetStyles.hidden);
    this.miniWidget.classList.remove(miniWidgetStyles.active);
  }
}